"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMBytecodeCompiler = void 0;
const inversify_1 = require("inversify");
const IVMDestructuringBytecodeCompiler_1 = require("../../interfaces/vm-transformers/compilers/IVMDestructuringBytecodeCompiler");
const IVMExpressionBytecodeCompiler_1 = require("../../interfaces/vm-transformers/compilers/IVMExpressionBytecodeCompiler");
const IVMFunctionBytecodeCompiler_1 = require("../../interfaces/vm-transformers/compilers/IVMFunctionBytecodeCompiler");
const IVMParameterBytecodeCompiler_1 = require("../../interfaces/vm-transformers/compilers/IVMParameterBytecodeCompiler");
const IVMStatementBytecodeCompiler_1 = require("../../interfaces/vm-transformers/compilers/IVMStatementBytecodeCompiler");
const IVMCompilerUtils_1 = require("../../interfaces/vm-transformers/IVMCompilerUtils");
const IVMScopeManager_1 = require("../../interfaces/vm-transformers/IVMScopeManager");
const IVMClosureAnalyzer_1 = require("../../interfaces/vm-transformers/analyzers/IVMClosureAnalyzer");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const VMOpCode_1 = require("../../enums/vm-transformers/VMOpCode");
const NodeGuards_1 = require("../../node/NodeGuards");
const VMConstants_1 = require("../VMConstants");
let VMBytecodeCompiler = class VMBytecodeCompiler {
    constructor(destructuringCompiler, expressionCompiler, functionCompiler, parameterCompiler, statementCompiler, vmCompilerUtils, closureAnalyzer, scopeManager) {
        this.destructuringCompiler = destructuringCompiler;
        this.expressionCompiler = expressionCompiler;
        this.functionCompiler = functionCompiler;
        this.parameterCompiler = parameterCompiler;
        this.statementCompiler = statementCompiler;
        this.vmCompilerUtils = vmCompilerUtils;
        this.closureAnalyzer = closureAnalyzer;
        this.scopeManager = scopeManager;
    }
    createDispatchForContext(ctx) {
        return {
            expression: (node) => this.compileExpression(node, ctx),
            statement: (node) => this.compileStatement(node, ctx),
            destructuring: (pattern, consumeValue, isAssignment) => this.compileDestructuringPattern(pattern, ctx, consumeValue, isAssignment),
            function: (node) => this.compile(node),
            functionExpression: (node) => this.compileFunctionExpression(node, ctx),
            compoundOperator: (operator) => this.compileCompoundOperator(operator, ctx)
        };
    }
    compile(functionNode, topLevelVariables) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const context = this.vmCompilerUtils.createContext(undefined, false, topLevelVariables);
        context.dispatchFactory = this.createDispatchForContext.bind(this);
        context.dispatch = context.dispatchFactory(context);
        if (NodeGuards_1.NodeGuards.isFunctionExpressionNode(functionNode) && ((_a = functionNode.id) === null || _a === void 0 ? void 0 : _a.name)) {
            context.functionName = functionNode.id.name;
        }
        else if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(functionNode) && ((_b = functionNode.id) === null || _b === void 0 ? void 0 : _b.name)) {
            context.functionName = functionNode.id.name;
        }
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(functionNode.body)) {
            this.preRegisterFunctionDeclarations(functionNode.body, context);
        }
        this.closureAnalyzer.analyzeEnvironmentVariables(functionNode, context);
        const hasNonParameterEnvVars = Array.from(context.envVars).some((varName) => !context.parameters.has(varName));
        let topLevelEnvHandle = null;
        if (hasNonParameterEnvVars) {
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            topLevelEnvHandle = this.scopeManager.enterEnv(context, builder, !context.parentContext);
            context.needsEnvRestoreAtEnd = true;
        }
        this.parameterCompiler.compileParameters(functionNode.params, context);
        const functionBodyStartIndex = context.instructions.length;
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(functionNode.body)) {
            this.hoistVarDeclarations(functionNode.body, context);
        }
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(functionNode.body) && context.declaredVariables) {
            this.scanVariableDeclarations(functionNode.body, context);
        }
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(functionNode.body)) {
            this.hoistFunctionDeclarations(functionNode.body, context);
        }
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(functionNode.body)) {
            this.functionCompiler.initializeHoistedVarEnvVariables(functionNode.body, context);
        }
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(functionNode.body)) {
            const lexicalDeclarations = this.scanForLexicalDeclarations(functionNode.body.body);
            if (lexicalDeclarations.size > 0) {
                this.scopeManager.enterLocalsTDZ(context, [...lexicalDeclarations]);
            }
            const tdzBuilder = this.vmCompilerUtils.createInstructionBuilder(context);
            for (const varName of lexicalDeclarations) {
                if (context.envVars.has(varName)) {
                    tdzBuilder.declareTDZ(varName);
                }
            }
        }
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(functionNode.body)) {
            for (const statement of functionNode.body.body) {
                this.compileStatement(statement, context);
            }
        }
        else {
            this.compileExpression(functionNode.body, context);
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            builder.return();
        }
        const isArrow = NodeGuards_1.NodeGuards.isArrowFunctionExpressionNode(functionNode);
        if (!isArrow) {
            let needsThisStorage = false;
            let needsArgumentsStorage = false;
            for (const [, nestedBytecode] of context.nestedFunctions) {
                if ((_c = nestedBytecode.capturedVars) === null || _c === void 0 ? void 0 : _c.includes(VMConstants_1.VM_SPECIAL_VARS.capturedThis)) {
                    needsThisStorage = true;
                }
                if ((_d = nestedBytecode.capturedVars) === null || _d === void 0 ? void 0 : _d.includes(VMConstants_1.VM_SPECIAL_VARS.capturedArguments)) {
                    needsArgumentsStorage = true;
                }
                if (needsThisStorage && needsArgumentsStorage) {
                    break;
                }
            }
            const storageInstructions = [];
            if (needsThisStorage) {
                const thisNameIndex = context.constantPool.add(VMConstants_1.VM_SPECIAL_VARS.capturedThis);
                storageInstructions.push({ op: VMOpCode_1.VMOpCode.THIS }, { op: VMOpCode_1.VMOpCode.STORE_TO_ENV, arg: thisNameIndex }, { op: VMOpCode_1.VMOpCode.POP });
            }
            if (needsArgumentsStorage) {
                const argumentsNameIndex = context.constantPool.add(VMConstants_1.VM_SPECIAL_VARS.capturedArguments);
                storageInstructions.push({ op: VMOpCode_1.VMOpCode.ARGUMENTS, arg: 0 }, { op: VMOpCode_1.VMOpCode.STORE_TO_ENV, arg: argumentsNameIndex }, { op: VMOpCode_1.VMOpCode.POP });
            }
            if (storageInstructions.length > 0) {
                context.instructions.splice(functionBodyStartIndex, 0, ...storageInstructions);
                this.vmCompilerUtils.adjustJumpTargetsAfterInsertion(functionBodyStartIndex, storageInstructions.length, context);
            }
        }
        if (topLevelEnvHandle) {
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            this.scopeManager.exitEnv(context, builder, topLevelEnvHandle);
        }
        const lastInstr = context.instructions[context.instructions.length - 1];
        if (!lastInstr || lastInstr.op !== VMOpCode_1.VMOpCode.RETURN) {
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            builder.pushUndefined().return();
        }
        let functionNameIndex;
        if (NodeGuards_1.NodeGuards.isFunctionExpressionNode(functionNode) && ((_e = functionNode.id) === null || _e === void 0 ? void 0 : _e.name)) {
            functionNameIndex = context.constantPool.add(functionNode.id.name);
        }
        else if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(functionNode) && ((_f = functionNode.id) === null || _f === void 0 ? void 0 : _f.name)) {
            functionNameIndex = context.constantPool.add(functionNode.id.name);
        }
        const mainBytecode = {
            id: context.nextBytecodeId++,
            constants: context.constantPool.getAll(),
            instructions: context.instructions,
            params: context.parameters.size,
            locals: Math.max(context.localVariables.size, context.maxLocals),
            functionRefIndices: context.functionRefIndices,
            isArrow: context.isArrowFunction,
            isAsync: (_g = functionNode.async) !== null && _g !== void 0 ? _g : false,
            isGenerator: (_h = functionNode.generator) !== null && _h !== void 0 ? _h : false,
            functionNameIndex: functionNameIndex
        };
        const nestedFunctions = Array.from(context.nestedFunctions.values());
        nestedFunctions.forEach((nf, i) => { });
        return {
            bytecode: mainBytecode,
            nestedFunctions
        };
    }
    compileBlock(blockStatement, params) {
        const context = this.vmCompilerUtils.createContext();
        this.compileStatement(blockStatement, context);
        return {
            id: context.nextBytecodeId++,
            constants: context.constantPool.getAll(),
            instructions: context.instructions,
            params,
            locals: Math.max(context.localVariables.size, context.maxLocals)
        };
    }
    hoistVarDeclarations(blockStatement, context) {
        for (const statement of blockStatement.body) {
            this.vmCompilerUtils.traverseBlocksSkipScopes(statement, (node) => {
                if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(node) && node.kind === 'var') {
                    for (const declarator of node.declarations) {
                        const identifiers = this.vmCompilerUtils.extractIdentifiersFromPattern(declarator.id);
                        for (const varName of identifiers) {
                            if (context.localVariables.has(varName)) {
                                continue;
                            }
                            const localIndex = context.localVariables.size;
                            context.localVariables.set(varName, localIndex);
                        }
                    }
                }
            });
        }
    }
    preRegisterFunctionDeclarations(blockStatement, context) {
        for (const statement of blockStatement.body) {
            if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(statement) && statement.id) {
                const funcName = statement.id.name;
                if (!context.localVariables.has(funcName)) {
                    const localIndex = context.localVariables.size;
                    context.localVariables.set(funcName, localIndex);
                }
            }
        }
    }
    hoistFunctionDeclarations(blockStatement, context) {
        for (const statement of blockStatement.body) {
            if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(statement) && statement.id) {
                const funcName = statement.id.name;
                this.compileStatement(statement, context);
                context.hoistedFunctionDeclarations.add(funcName);
            }
        }
    }
    scanVariableDeclarations(blockStatement, context) {
        if (!context.declaredVariables) {
            return;
        }
        for (const statement of blockStatement.body) {
            if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(statement) && statement.id) {
                context.declaredVariables.add(statement.id.name);
            }
            else if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(statement)) {
                for (const declarator of statement.declarations) {
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(declarator.id)) {
                        context.declaredVariables.add(declarator.id.name);
                    }
                    else if (NodeGuards_1.NodeGuards.isObjectPatternNode(declarator.id) ||
                        NodeGuards_1.NodeGuards.isArrayPatternNode(declarator.id)) {
                        this.extractIdentifiersFromPattern(declarator.id, context.declaredVariables);
                    }
                }
            }
        }
    }
    extractIdentifiersFromPattern(pattern, declaredVars) {
        if (NodeGuards_1.NodeGuards.isIdentifierNode(pattern)) {
            declaredVars.add(pattern.name);
        }
        else if (NodeGuards_1.NodeGuards.isObjectPatternNode(pattern)) {
            for (const prop of pattern.properties) {
                if (NodeGuards_1.NodeGuards.isPropertyNode(prop)) {
                    this.extractIdentifiersFromPattern(prop.value, declaredVars);
                }
                else if (NodeGuards_1.NodeGuards.isRestElementNode(prop)) {
                    this.extractIdentifiersFromPattern(prop.argument, declaredVars);
                }
            }
        }
        else if (NodeGuards_1.NodeGuards.isArrayPatternNode(pattern)) {
            for (const element of pattern.elements) {
                if (element) {
                    this.extractIdentifiersFromPattern(element, declaredVars);
                }
            }
        }
        else if (NodeGuards_1.NodeGuards.isAssignmentPatternNode(pattern)) {
            this.extractIdentifiersFromPattern(pattern.left, declaredVars);
        }
        else if (NodeGuards_1.NodeGuards.isRestElementNode(pattern)) {
            this.extractIdentifiersFromPattern(pattern.argument, declaredVars);
        }
    }
    compileStatement(node, context) {
        switch (node.type) {
            case 'BlockStatement':
                this.statementCompiler.compileBlockStatement(node, context);
                break;
            case 'ExpressionStatement': {
                this.compileExpression(node.expression, context);
                const builder = this.vmCompilerUtils.createInstructionBuilder(context);
                builder.pop();
                break;
            }
            case 'ReturnStatement':
                this.statementCompiler.compileReturnStatement(node, context);
                break;
            case 'IfStatement':
                this.statementCompiler.compileIfStatement(node, context);
                break;
            case 'WhileStatement':
                this.statementCompiler.compileWhileStatement(node, context);
                break;
            case 'DoWhileStatement':
                this.statementCompiler.compileDoWhileStatement(node, context);
                break;
            case 'ForStatement':
                this.statementCompiler.compileForStatement(node, context);
                break;
            case 'ForOfStatement':
                this.statementCompiler.compileForOfStatement(node, context);
                break;
            case 'ForInStatement':
                this.statementCompiler.compileForInStatement(node, context);
                break;
            case 'BreakStatement':
                this.statementCompiler.compileBreakStatement(node, context);
                break;
            case 'ContinueStatement':
                this.statementCompiler.compileContinueStatement(node, context);
                break;
            case 'ThrowStatement':
                this.statementCompiler.compileThrowStatement(node, context);
                break;
            case 'TryStatement':
                this.statementCompiler.compileTryStatement(node, context);
                break;
            case 'VariableDeclaration':
                this.statementCompiler.compileVariableDeclaration(node, context);
                break;
            case 'FunctionDeclaration':
                this.statementCompiler.compileFunctionDeclaration(node, context);
                break;
            case 'ClassDeclaration':
                this.statementCompiler.compileClassDeclaration(node, context);
                break;
            case 'SwitchStatement':
                this.statementCompiler.compileSwitchStatement(node, context);
                break;
            case 'LabeledStatement':
                this.statementCompiler.compileLabeledStatement(node, context);
                break;
            default: {
                const builder = this.vmCompilerUtils.createInstructionBuilder(context);
                builder.emitRaw({ op: VMOpCode_1.VMOpCode.NOP });
                break;
            }
        }
    }
    compileExpression(node, context) {
        this.expressionCompiler.compileExpression(node, context);
    }
    compileFunctionExpression(node, context) {
        this.functionCompiler.compileFunctionExpression(node, context);
    }
    compileCompoundOperator(operator, context) {
        this.functionCompiler.compileCompoundOperator(operator, context);
    }
    compileDestructuringPattern(pattern, context, consumeValue = false, isAssignment = false) {
        this.destructuringCompiler.compileDestructuringPattern(pattern, context, consumeValue, isAssignment);
    }
    scanForLexicalDeclarations(statements) {
        const lexicalVars = new Set();
        for (const stmt of statements) {
            if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(stmt)) {
                if (stmt.kind === 'let' || stmt.kind === 'const') {
                    for (const decl of stmt.declarations) {
                        if (NodeGuards_1.NodeGuards.isIdentifierNode(decl.id)) {
                            lexicalVars.add(decl.id.name);
                        }
                        else if (NodeGuards_1.NodeGuards.isArrayPatternNode(decl.id) || NodeGuards_1.NodeGuards.isObjectPatternNode(decl.id)) {
                            this.extractIdentifiersFromPattern(decl.id, lexicalVars);
                        }
                    }
                }
            }
        }
        return lexicalVars;
    }
};
exports.VMBytecodeCompiler = VMBytecodeCompiler;
exports.VMBytecodeCompiler = VMBytecodeCompiler = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMDestructuringBytecodeCompiler)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMExpressionBytecodeCompiler)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMFunctionBytecodeCompiler)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMParameterBytecodeCompiler)),
    __param(4, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMStatementBytecodeCompiler)),
    __param(5, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils)),
    __param(6, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMClosureAnalyzer)),
    __param(7, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMScopeManager)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMDestructuringBytecodeCompiler_1.IVMDestructuringBytecodeCompiler !== "undefined" && IVMDestructuringBytecodeCompiler_1.IVMDestructuringBytecodeCompiler) === "function" ? _a : Object, typeof (_b = typeof IVMExpressionBytecodeCompiler_1.IVMExpressionBytecodeCompiler !== "undefined" && IVMExpressionBytecodeCompiler_1.IVMExpressionBytecodeCompiler) === "function" ? _b : Object, typeof (_c = typeof IVMFunctionBytecodeCompiler_1.IVMFunctionBytecodeCompiler !== "undefined" && IVMFunctionBytecodeCompiler_1.IVMFunctionBytecodeCompiler) === "function" ? _c : Object, typeof (_d = typeof IVMParameterBytecodeCompiler_1.IVMParameterBytecodeCompiler !== "undefined" && IVMParameterBytecodeCompiler_1.IVMParameterBytecodeCompiler) === "function" ? _d : Object, typeof (_e = typeof IVMStatementBytecodeCompiler_1.IVMStatementBytecodeCompiler !== "undefined" && IVMStatementBytecodeCompiler_1.IVMStatementBytecodeCompiler) === "function" ? _e : Object, typeof (_f = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _f : Object, typeof (_g = typeof IVMClosureAnalyzer_1.IVMClosureAnalyzer !== "undefined" && IVMClosureAnalyzer_1.IVMClosureAnalyzer) === "function" ? _g : Object, typeof (_h = typeof IVMScopeManager_1.IVMScopeManager !== "undefined" && IVMScopeManager_1.IVMScopeManager) === "function" ? _h : Object])
], VMBytecodeCompiler);
